module.exports = __webpack_public_path__ + "img/img5.ad6bb4c8.png";